import React, {useState, useEffect}from 'react'
import Card from 'react-bootstrap/Card';
import alertIcon from '../../assets/icons/alert-icon.svg';
import PropTypes from "prop-types";

const DnaPartialReportCard = ({partialMarker}) => {
   const [title, setTitle] = useState('');
   useEffect(() => {
  if(partialMarker !== null){
    if (partialMarker?.missing_snps?.length > 1) {
      setTitle("both rs2187668 and rs4639334 results not reported");
    } else if (partialMarker?.missing_snps?.[0] === "rs2187668") {
      setTitle("rs2187668 result not reported");
    } else if (partialMarker?.missing_snps?.[0] === "rs4639334") {
      setTitle("rs4639334 result not reported");
    }
   }
}, [partialMarker]);
   
    return (
        <Card className='dna-partial-report-card'>
            <Card.Body>
                <div className="d-flex align-items-start">
                    <div className="icon-col">
                        <img
                            src={alertIcon}
                            alt="Alert Icon"
                            className="dna-alert-icon"
                        />
                    </div>

                    <div className="dna-content-col">
                        <Card.Title className="dna-title">
                            Gluten Intolerance – <span>{title}</span>
                        </Card.Title>

                        <Card.Text className="dna-text">
                            {partialMarker?.partial_message}
                        </Card.Text>
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}
DnaPartialReportCard.propTypes = {
 partialMarker: PropTypes.object
};
export default DnaPartialReportCard